import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';
import { IOneTimePoll } from '../../../../types/rest/IUserMeta';
import { DEFAULT_POLL } from '../../../../const';

export const getUserRateKanbanPoll = (
    state: IApplicationState
): IOneTimePoll => {
    const user = getAuthUser(state);
    return user.meta && user.meta.rateKanbanPoll || DEFAULT_POLL;
};
